/**
 * Hands a fetched file to the browser's own download flow.
 *
 * The file arrives through `fetch` because it needs the Authorization header, so a
 * plain `<a href>` to the endpoint cannot do this. An object URL on a synthetic
 * link is the standard bridge back. The URL is revoked afterwards — each one pins
 * its blob in memory for the life of the page, and an afternoon of exports would
 * quietly hold every spreadsheet ever downloaded.
 */
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
};
